import { SignUp } from "aws-amplify-react/lib/Auth";
import { AuthState } from "@aws-amplify/ui-components";
import { Auth } from "aws-amplify";
import axios from "axios";
import "./login.css";
import validator from "validator";
import fondo from "../img-login/fondo-ht.jpg"
import MuiAlert from "@material-ui/lab/Alert";
import MODAL_TABLE from "../main_components/modal/modal_Table";
export class CustomSignUp extends SignUp {
  constructor(props) {
    super(props);

    this.state = {
      Username: "",
      Password: "",
      RePassword: "",
      Mail: "",
      Name: "",
      RFC: "",
      ID_COMPANY: "",
      ID_USER: "",
      ROLES: "",
      IsLoading: false,
    };

    this.signUp = this.signUp.bind(this);
    this.handleFormSubmission = this.handleFormSubmission.bind(this);
  }

  Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }
  handleFormSubmission(evt) {
    var emailRegex =
      /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i;

    if (this.state.Username.length > 0) {
      if (
        validator.isStrongPassword(this.state.Password, {
          minLength: 8,
          minLowercase: 1,
          minUppercase: 1,
          minNumbers: 1,
          minSymbols: 1,
        })
      ) {
        if (
          this.state.Password === this.state.RePassword &&
          this.state.Password !== ""
        ) {
          if (emailRegex.test(this.state.Mail)) {
            this.setState({ IsLoading: true });

            var config = {
              method: "post",
              url: "https://y9wepklqsb.execute-api.us-east-1.amazonaws.com/od/pre-signup",
              data: {
                email: this.state.Mail,
                rfc: this.state.RFC,
                name: this.state.Name,
                username: this.state.Username,
                is_supplier: false
              },
            };

            axios(config)
              .then((response) => {
                this?.signUp();
              })
              .catch((error) => { 
                console.log(error);
                console.log(error?.response);
                console.log(error?.response?.data?.errorMessage);
                var erroDM = error?.response?.data?.errorMessage?.es;
                if (erroDM === undefined) {
                  alert(
                    "Error al obtener sus datos, verifique que su correo esté autorizado para registrarse en od2"
                  );
                } else {
                  alert(erroDM + " verifique sus datos");
                }
                this.setState({ IsLoading: false }); 
              });

          } else {
            alert("El correo electronico esta mal estructurado reviselo");
          }
        } else {
          alert("Las contraseñas no son iguales");
        }
      } else {
        alert(
          "La contraseña debe contener al menos 8 carcateres, una minuscula, una mayuscula, un número y un símbolo especial"
        );
      }
    } else {
      alert("Error: Debe subministrar un nombre de usuario");
    }
  }

  mostrarContrasena() {
    var tipo = document.getElementById("password-field");
    if (tipo.type === "password") {
      tipo.type = "text";
    } else {
      tipo.type = "password";
    }
  }

  mostrarContrasena2() {
    var tipo = document.getElementById("password-field2");
    if (tipo.type === "password") {
      tipo.type = "text";
    } else {
      tipo.type = "password";
    }
  }

  async signUp() {
    const username = this.state.Username;
    const password = this.state.Password;
    const email = this.state.Mail;
    const rfc = this.state.RFC;
    const name = this.state.Name;

    this.setState({ IsLoading: true });

    try {
      const config = {
        method: "post",
        url: "https://y9wepklqsb.execute-api.us-east-1.amazonaws.com/od/pre-signup",
        data: {
          email,
          rfc,
          name,
          username,
          is_supplier: false
        },
      };

      const response = await axios(config);
      const id_company = response.data.id_company;
      const id_user = response.data.id_user;
      const roles = response.data.roles;

      try {
        const { user } = await Auth.signUp({
          username,
          password,
          attributes: {
            email,
            name,
            "custom:rfc_company": rfc,
            "custom:id_user": `${id_user}`,
            "custom:roles": roles,
            "custom:id_company": `${id_company}`,
          },
        });

        this.props.SetUserName(user["username"]);
        this.props.SetAuthState(AuthState.ConfirmSignUp);
      } catch (authError) {
        console.error("Auth Error:", authError);

        if (
          authError.name === "UsernameExistsException" ||
          authError.message.includes("An account is registered with this email")
        ) {
          alert("Ya existe una cuenta registrada con este correo electrónico. Si olvidó su contraseña, recupérela desde la pantalla de inicio de sesión.");
        } else {
          alert("Ocurrió un error al crear su cuenta. Intente nuevamente más tarde.");
        }
      }
    } catch (error) {
      console.error("API Error:", error);
      const msg = error?.response?.data?.errorMessage;

      if (msg?.includes("An account is registered with this email")) {
        alert("Ya existe una cuenta registrada con este correo electrónico. Si olvidó su contraseña, recupérela desde la pantalla de inicio de sesión.");
      } else {
        alert("Error al obtener sus datos. Verifique que su correo esté autorizado para registrarse.");
      }
    } finally {
      this.setState({ IsLoading: false });
    }
  }



  render() {
    return (
      <div className='container_login'>
        <MODAL_TABLE modalGeneral={this.state.IsLoading} modalT={this.state.IsLoading} message={"Ingresando..."}></MODAL_TABLE>

        <div className='grid-login'>
          <div className='formsesion'>
            <div className='camplogin'>
              < div className="div-lg2">
                <p className='bienvenido'>Registrarse</p>
                {/* <p className='text-login'>Inicia sesión para continuar</p> */}
              </div>

              <div className='grid-form-login'>
                <div className='form-register'>
                  <label className='label-usuario'>Nombre de usuario</label>
                  <input
                    className="form-control text-center txtmin "
                    type="text"
                    placeholder="Nombre de usuario"
                    onChange={(e) =>
                      this.setState({
                        Username: e.target.value?.toLowerCase()?.trim(),
                      })
                    }
                    value={this.state.Username}
                  ></input>
                </div>
                <div className='form-register'>
                  <label className='label-usuario'>Nombre completo</label>
                  <input
                    className="text-center form-control"
                    type="text"
                    placeholder="Nombre completo"
                    onChange={(e) =>
                      this.setState({ Name: e.target.value.toUpperCase() })
                    }
                    value={this.state.Name}
                  ></input>
                </div>
                <div className='form-register'>
                  <label className='label-usuario'>RFC</label>
                  <input
                    className="text-center form-control"
                    type="text"
                    placeholder="RFC de la empresa"
                    onChange={(e) =>
                      this.setState({ RFC: e.target.value.toUpperCase().trim() })
                    }
                    value={this.state.RFC}
                  ></input>
                </div>
                <div className='form-register'>
                  <label className='label-usuario'>Correo</label>
                  <input
                    className="text-center form-control"
                    type="email"
                    placeholder="Correo electronico"
                    onChange={(e) =>
                      this.setState({ Mail: e.target.value.trim() })
                    }
                    value={this.state.Mail}
                  ></input>
                </div>
                <div className='form-pass'>

                  <div className='pass1grid'>
                    <label className='label-contraseña'>Contraseña</label>
                    <input
                      id="password-field"
                      className="text-center form-control"
                      type="password"
                      placeholder="Contraseña"
                      onChange={(e) =>
                        this.setState({ Password: e.target.value.trim() })
                      }
                      value={this.state.Password}
                    ></input>
                    <span
                      className="material-symbols-outlined  field-icon "
                      onClick={this.mostrarContrasena}
                    >
                      visibility
                    </span>
                  </div>
                </div>
                <div className='form-pass'>
                  <div className='pass1grid'>

                    <label className='label-contraseña'>Confirmar Contraseña</label>
                    <input
                      id="password-field2"
                      className="text-center form-control"
                      type="password"
                      placeholder="Confirmar contraseña"
                      onChange={(e) =>
                        this.setState({ RePassword: e.target.value.trim() })
                      }
                      value={this.state.RePassword}
                    ></input>
                    <span
                      className="material-symbols-outlined  field-icon "
                      onClick={this.mostrarContrasena2}
                    >
                      visibility
                    </span>
                  </div>
                </div>
                <div className=''>
                  <button className='boton-registrarse'
                    onClick={this.handleFormSubmission}
                  >
                    Registrarse
                  </button>
                  <button className='boton-login'
                    onClick={() => this.props.SetAuthState(AuthState.SignIn)}>
                    Iniciar Sesión
                  </button>
                </div>
              </div>

            </div>
          </div>
          <div className='imglogin'>
            <img src={fondo}></img>
          </div>
        </div>
      </div>
    );
  }
}

export default CustomSignUp;

